<template>
    <div>
        <h4>{{ $t('monitoring.tabs_label__technical_report') }}</h4>
        <!-- <h4>Reporting Period 2</h4> -->
        <div class="col-lg-4">
            <!-- Start & End date -->
            <div class="row">
                <!-- Starting date -->
                <div class="col-lg-6">
                    <base-input
                        name="report.start_date"
                        v-model="MonitoringForm.report.start_date"
                        :error="getError('report.start_date')"
                        v-validate="'required'"
                        :data-vv-as="$t('medium_grant.technical__1_startdate')"
                        :placeholder="$t('medium_grant.technical__1_startdate')"
                        >
                        <label>{{$t('medium_grant.technical__1_startdate')}}</label>
                        <el-date-picker
                            type="date"
                            v-model="startDate"
                            :placeholder="$t('medium_grant.technical__1_startdate')"
                            >
                        </el-date-picker>
                    </base-input>
                </div>

                <!-- Ending date -->
                <div class="col-lg-6">
                    <base-input
                        name="report.end_date"
                        v-model="MonitoringForm.report.end_date"
                        :placeholder="$t('medium_grant.technical__1_enddate')"
                        :error="getError('report.end_date')"
                        v-validate="'required'"
                        :data-vv-as="$t('medium_grant.technical__1_enddate')"
                        >
                        <label>{{$t('medium_grant.technical__1_enddate')}}</label>
                        <el-date-picker
                            type="date"
                            v-model="endDate"
                            :placeholder="$t('medium_grant.technical__1_enddate')"
                            >
                        </el-date-picker>
                    </base-input>
                </div>
            </div>
        </div>

        <upload-file
            v-if="MonitoringForm.initialized"
            v-model="MonitoringForm.files.technical.report"
            section="technical.report"
            class="upload-report-box"
            :file-data="MonitoringForm.files.technical.report"
            :is-editable="MonitoringForm.isEditable"
            :model-name="'MonitoringReport'"
            :size-limit="MonitoringForm.fileSizeLimit"
            >
            <div class="row">
                <div class="col-lg-12 upload-report-inner-box">
                    <h4>{{ $t('monitoring.button_title__upload_report') }}</h4>
                </div>
            </div>
        </upload-file>

        <div class="" v-for="(field, index) in fileKeys" :key="'custom_field_' + index">
            <upload-file
                v-if="MonitoringForm.initialized"
                v-model="MonitoringForm.files.technical[field]"
                class="upload-report-box"
                :section="'technical.' + field"
                :file-data="MonitoringForm.files.technical[field]"
                :is-editable="MonitoringForm.isEditable"
                :model-name="'MonitoringReport'"
                :size-limit="MonitoringForm.fileSizeLimit"
            >
            <div class="row">
                <div class="col-lg-12 upload-report-inner-box">
                    <h4>+ {{ $t('reports.annexure') }} {{index+1}}</h4>
                </div>
            </div>
            </upload-file>
            <!-- <span class="msd-remove-item tim-icons icon-trash-simple" @click="removeSupportField(field, index)" v-if="MonitoringForm.isEditable"></span> -->
        </div>
        <base-button
            v-if="MonitoringForm.isEditable && fileKeys.length < parseInt(MonitoringForm.max_annexure)"
            type="primary"
            class="add-new-document"
            @click="addNewSupportingDocument()"
            >
            + {{ $t('reports.add_annexure') }}
        </base-button>
    </div>
</template>
<script>
    import {MonitoringService, UserRoles, FileUploadService, MonitoringForm} from '@/services';
    import {EventBus} from '@/event-bus.js';
    import {DatePicker} from 'element-ui';
    import Multiselect from 'vue-multiselect';

    export default
    {
        components:
        {
            MonitoringForm,
            [DatePicker.name]: DatePicker,
            Multiselect,
        },
        data()
        {
            return {
                MonitoringForm,
                startDate: '',
                endDate: '',
                reportId: parseInt(this.$route.params.reportId) || null,
                technicalFiles: {},
                fileKeys: []
            }
        },
        async beforeMount()
        {
            const vm = this;

            vm.moment = require('moment');

            vm.startDate = MonitoringForm.report.start_date || '';
            vm.endDate = MonitoringForm.report.end_date || '';

            // for multiple file uploading
            vm.technicalFiles = MonitoringForm.files.technical;
            vm.fileKeys = Object.keys(vm.technicalFiles).filter(x => x !== 'report');
        },
        methods:
        {
            getError(field)
            {
                return this.errors.first(field);
            },

            validate()
            {
                return this.$validator.validateAll().then(res =>
                {
                    this.$emit('on-validated', res, this.model);

                    return res;
                });
            },

            addNewSupportingDocument()
            {
                const last_index = this.fileKeys.length;

                this.fileKeys.push(`additional_document_${last_index}_${(+new Date())}`);

                this.$forceUpdate();
            },

            removeSupportField(subgroup, index)
            {
                if (confirm(this.$t('monitoring.confirm__remove_field')))
                {
                    this.fileKeys.splice(index, 1);
                }
            },
        },
        watch:
        {
            startDate(new_val)
            {
                MonitoringForm.report.start_date = this.moment(new_val).format('YYYY-MM-DD');
            },
            endDate(new_val)
            {
                MonitoringForm.report.end_date = this.moment(new_val).format('YYYY-MM-DD');
            }
        }
    };
</script>
